<div *ngIf="pills.length > 0" class="product-list-container" tabindex="0">
  <ion-button *ngIf="allProductsPill" (click)="pillSelect.emit(allProductsPill)" (keydown.enter)="pillSelect.emit(allProductsPill)"
    [class.active]="allProductsPill.id === activePillId" fill="clear" size="small" class="product-button all-pill">
    {{ allProductsPill.name }}
  </ion-button>
  <div class="product-divider"></div>
  <div class="product-section">
    <div class="product-group" *ngIf="ownProductPills.length > 0">
      <div class="product-group-pills">
        <ion-button *ngFor="let product of ownProductPills"
          (click)="pillSelect.emit(product)" (keydown.enter)="pillSelect.emit(product)"
          [class.active]="product.id === activePillId" fill="clear" size="small" class="product-button">
          {{ product.name }}
        </ion-button>
      </div>
    </div>
    <div class="product-group" *ngIf="competitorProductPills.length > 0">
      <div class="product-group-pills">
        <ion-button *ngFor="let product of competitorProductPills"
          (click)="pillSelect.emit(product)" (keydown.enter)="pillSelect.emit(product)"
          [class.active]="product.id === activePillId" fill="clear" size="small" class="product-button competitor">
          {{ product.name }}
        </ion-button>
      </div>
    </div>
  </div>
</div>
